<template>
  <div class="video-panel">
    <van-action-sheet :close-on-click-overlay="false" :value="showVideoSet" title="画面设置" @cancel="handleCancel">
      <div class="content">
        <div class="panel-item" :class="{active: !video.doubleUrl}">
          <div class="cover">主画面</div>
          <div class="item">
            <span>画面</span>
            <van-switch size="24px" :value="video.showMainScreen" @input="mainInput" />
          </div>
        </div>
        <div class="panel-item" v-if="video.doubleUrl">
          <div class="cover">副画面</div>
          <div class="item">
            <span>画面</span>
            <van-switch size="24px" :value="video.showSubScreen" @input="subInput" />
          </div>
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    showVideoSet() {
      return this.$store.state.activePlay.panel.showVideoSet
    }
  },
  methods: {
    handleCancel() {
      this.$store.commit('controlPanel', {showVideoSet: false})
    },
    mainInput(val) {
      const mainVideo = document.getElementById('mainVideoElement')
      if (!val) {
        mainVideo.volume = 0
      } else {
        mainVideo.volume = 1
      }
      this.$store.commit('controlVideo', {showMainScreen: val})
    },
    subInput(val) {
      const subVideo = document.getElementById('subVideoElement')
      if (!val) {
        subVideo.volume = 0
      } else {
        subVideo.volume = 1
      }
      this.$store.commit('controlVideo', {showSubScreen: val})
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  padding: 16px;
  display: flex;
  justify-content: space-between;
}
.panel-item {
  &.active {
    margin: 0 auto;
  }
  width: 48%;
  .cover {
    background: rgba(68, 101, 243, 0.2);
    border-radius: 8px;
    height: 90px;
    color: #4465f3;
    text-align: center;
    line-height: 90px;
  }
}
.item {
  display: flex;
  justify-items: center;
  justify-content: center;
  margin-top: 20px;
  > span {
    margin-right: 10px;
  }
}
</style>
